import { useOutletContext } from 'react-router';

export type GalleryRarityLayoutContext = {
  cardSets: {
    slug: string;
    name: string;
  }[];
};
export const useGalleryRarityLayoutContext = () => {
  return useOutletContext<GalleryRarityLayoutContext>();
};
